import { useState } from 'react'
import { InterviewStatus, type ChatMessage } from '@bosmart/types'
import type { SessionSetters, SessionUiState } from './types'

export function useSessionUiState(): SessionUiState & SessionSetters {
  const [status, setStatus] = useState<InterviewStatus>(InterviewStatus.SETUP)
  const [aiSpeaking, setAiSpeaking] = useState(false)
  const [transcription, setTranscription] = useState({ user: '', model: '' })
  const [error, setError] = useState<string | null>(null)
  const [notification, setNotification] = useState<string | null>(null)
  const [isScreenSharing, setIsScreenSharing] = useState(false)
  const [isMuted, setIsMuted] = useState(false)
  const [history, setHistory] = useState<ChatMessage[]>([])
  const [modelActive, setModelActive] = useState(false)
  const [userActive, setUserActive] = useState(false)
  const [hasGreetingReceived, setHasGreetingReceived] = useState(false)
  const [showStartCue, setShowStartCue] = useState(false)
  const [showSpeakFirstPrompt, setShowSpeakFirstPrompt] = useState(false)
  const [isCallEnding, setIsCallEnding] = useState(false)
  const [showConfirmation, setShowConfirmation] = useState(false)
  const [showThankYou, setShowThankYou] = useState(false)
  const [duration, setDuration] = useState(0)
  const [isTimerRunning, setIsTimerRunning] = useState(false)

  return {
    status,
    aiSpeaking,
    transcription,
    error,
    notification,
    isScreenSharing,
    isMuted,
    history,
    modelActive,
    userActive,
    hasGreetingReceived,
    showStartCue,
    showSpeakFirstPrompt,
    isCallEnding,
    showConfirmation,
    showThankYou,
    duration,
    isTimerRunning,
    setStatus,
    setAiSpeaking,
    setTranscription,
    setError,
    setNotification,
    setIsScreenSharing,
    setIsMuted,
    setHistory,
    setModelActive,
    setUserActive,
    setHasGreetingReceived,
    setShowStartCue,
    setShowSpeakFirstPrompt,
    setIsCallEnding,
    setShowConfirmation,
    setShowThankYou,
    setDuration,
    setIsTimerRunning,
  }
}
